import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Button, Link } from '@mui/material';
import useSubscription from '../../hooks/useSubscription';
import { TrialBannerWrapper, TrialBannerText } from './styling';
import { TrialBannerProps } from './types';

dayjs.extend(relativeTime);

function TrialBanner(
  {
    onBuyNowClick,
    onRedeemTokenClick,
  }: TrialBannerProps) {
  const subscriptionQuery = useSubscription();
  const {data, isLoading, isError} = subscriptionQuery;

  if (isLoading || isError) return null;

  const trialEndsAt = data?.trial_ends ? dayjs().to(data.trial_ends) : '';

  return (
      <TrialBannerWrapper>
        <TrialBannerText>Trial ends {trialEndsAt}.</TrialBannerText>
        {' '}
        {data.has_billing_access ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={onBuyNowClick}
          >
            Buy now
          </Button>
        ) : null}
        {' '}
        <Link
          component="button"
          variant="body2"
          onClick={onRedeemTokenClick}
          sx={{cursor: 'pointer'}}
        >
          Have an invite code?
        </Link>
      </TrialBannerWrapper>
  );
}

export default TrialBanner;
